import React, {ChangeEvent, useContext, useEffect, useState} from "react";
import {Button} from "react-bootstrap";
import {AppContext} from "../../../../appContext/AppContext";
import CustomIconButton from "../../../../component/custom-icon-button/CustomIconButton";
import InputSearch from "../../../../component/InputSearch";
import {TableCustomHeader} from "../../../../component/table/components/TableCustomHeader";
import {TablePagination} from "../../../../component/table/components/TablePagination";
import {TableCustom} from "../../../../component/table/table-custom/TableCustom";
import {
  CODE,
  DEFAULT_PAGE_INDEX,
  KEY,
  SELECTION_MODE,
  STATUS_CODE,
  TYPE_WH,
} from "../../../../utils/Constant";
import {handlePagesChange, handleRowsPerPageChange, rowsForPage} from "../../../../utils/PageUtils";
import {BaoCaoYCHTDialogColumns} from "../../columns";
import "../BaoCaoThongKe.scss";
import DialogPhieuKeHoach from "./DialogBaoCaoThongKe";
import WfStatusSummary from "../../../../workflows/components/WfStatusSummary";
import {deletePhieuKeHoach, searchPhieuKeHoach} from "../services/services";
import {ConfirmDialog} from "../../../../component/ConfirmDialog";
import {toast} from "react-toastify";
import {getSummaryStatusWf} from "../../../../workflows/services/WfWorkflowsService";
import {formatDateFromDTOCustom, formatDateToDTOCustom} from "../../../../utils/FormatUtils";
import {
  TYPE_KE_HOACH, WMS_STATUS
} from "../constants/baoCaoThongKe";
import {TypeYeuCau} from "../models/BaoCaoModel";
import AutocompleteObjectV2 from "../../../../component/AutocompleteObjectV2";
import {useQuanLyNhanSuContext} from "../../../contexts/quanLyNhanSu";

interface Props {
  warehouseId: any;
  className?: any;
}

export const FormBaoCao = (props: Props) => {
  const {warehouseId, className} = props;
  const [typeKeHoach, setTypeKeHoach] = useState<TypeYeuCau>(TYPE_KE_HOACH[0]);
  const [dsPhieuKeHoach, setDsPhieuKeHoach] = useState<any[]>([]);
  const [openDialogThemMoi, setOpenDialogThemMoi] = useState<boolean>(false);
  const {setDsNhanSu, setDetailNhanSu} = useQuanLyNhanSuContext();
  const [openDialogConfirmDelete, setOpenDialogConfirmDelete] = useState<boolean>(false);
  const [itemSelected, setItemSelected] = useState<any>();
  const {setIsLoading} = useContext(AppContext);
  const [summaryStatus, setSummaryStatus] = useState<any>([]);
  const [searchData, setSearchData] = useState<any>();
  const [rowsPerPage, setRowsPerPage] = useState<number>(20);
  const [page, setPage] = useState<number>(DEFAULT_PAGE_INDEX);
  const [configTable, setConfigTable] = useState<any>({
    totalPages: 0,
    totalElements: 0,
    numberOfElements: 0,
  });


  const handleChangeSearchData = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchData({
      ...searchData,
      [e.target.name]: e.target.value,
    });
  };

  const handleDelete = async () => {
    try {
      setIsLoading(true);
      const res = await deletePhieuKeHoach(WMS_STATUS.build_plan, itemSelected.id);
      if (CODE.SUCCESS === res.status) {
        toast.success("Xóa phiếu thành công");
        handleCloseDialog();
      }
    } catch (error: any) {
      const message = error?.message || "Có lỗi xảy ra, vui lòng thử lại";
      toast.error(message)
      setIsLoading(false);
      console.error(error);
    }
  };


  const handleCloseDialog = () => {
    updatePageData();
    setDsNhanSu([]);
    setDetailNhanSu({});
    setOpenDialogConfirmDelete(false);
    setOpenDialogThemMoi(false);
    setItemSelected({});
  };

  const updatePageData = async () => {
    try {
      setIsLoading(true);
      const {data} = await searchPhieuKeHoach({
        ...searchData,
        keyword: searchData?.keyword?.trim() || null,
        doCreationFromDate: formatDateFromDTOCustom(searchData?.doCreationFromDate),
        doCreationToDate: formatDateToDTOCustom(searchData?.doCreationToDate),
        type: TYPE_WH.IMPORT,
        pageSize: rowsPerPage,
        pageIndex: page,
        trackerCode: typeKeHoach.trackerCode
      });
      const resSummary = await getSummaryStatusWf(
        typeKeHoach.trackerCode,
        {
          fromDate: formatDateFromDTOCustom(searchData?.doCreationFromDate) || null,
          toDate: formatDateToDTOCustom(searchData?.doCreationToDate) || null,
        }
      );
      console.log(resSummary.data.data)
      if (CODE.SUCCESS === resSummary.data?.code) {
        setSummaryStatus(resSummary.data.data);
      }
      if (CODE.SUCCESS === data.code) {
        setDsPhieuKeHoach(data?.data?.content || []);
        setConfigTable({
          totalPages: Math.ceil(data.data.pageable.totalElements / data.data.pageable.pageSize),
          totalElements: data?.data?.pageable?.totalElements,
          // numberOfElements: data?.data?.pageable?.pageNumber,
        })
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    updatePageData();
  }, [rowsPerPage, page, warehouseId, typeKeHoach.code]);


  const handlerSearchKeyWorld = () => {
    setPage(DEFAULT_PAGE_INDEX);
    setRowsPerPage(20);
    updatePageData()
  }
  const columnsActions = {

    Header: (props: any) => (
      <TableCustomHeader<any>
        tableProps={props}
        title={"Thao tác"}
        className='text-center text-light spaces w-80px'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => (
      <div className="d-flex justify-content-center gap-3">
        <CustomIconButton
          variant="edit"
          onClick={() => {
            setItemSelected(props.cell.row.original);
            setDetailNhanSu(props.cell.row.original)
            setOpenDialogThemMoi(true);
          }}
        >
          <i className="bi bi-pencil-square text-navy"></i>
        </CustomIconButton>
        {props.cell.row.original?.statusCode === STATUS_CODE.LUU_MOI ?
          <>
            <CustomIconButton
              variant="delete"
              onClick={() => {
                setItemSelected(props.cell.row.original);
                setOpenDialogConfirmDelete(true);
              }}
            >
              <i className="bi bi-trash3-fill text-danger"></i>
            </CustomIconButton>
          </> :
          <CustomIconButton
            variant="view"
            onClick={() => {
              setItemSelected(props.cell.row.original);
              setDetailNhanSu({...props.cell.row.original, isView: true})
              setOpenDialogThemMoi(true);
            }}
          >
            <i className="bi bi-eye"></i>
          </CustomIconButton>
        }
      </div>
    )
  };

  return (
    <div className="bg-white h-100">
      <div className="flex-1 flex flex-column">
        <div className="d-flex bg-gray ">
          <div className="spaces width-100 bg-gray radius-2">
            <div className="flex bg-white spaces width-100 ">
              <h4 className="text-title text-pri fw-bold fs-4 spaces mb-0 px-10 min-w-180">
                Báo cáo thống kê
              </h4>
            </div>
            <div className="d-flex  mt-1 flex-column spaces width-100 ">
              <div className="bg-white">
                <div className="d-flex spaces pr-8 mt-6 bg-white justify-content-between align-items-center mb-6">
                  <div className=" bg-white flex align-items-center mr-13 spaces">
                    <Button className="btn-fill ml-10 mr-4 spaces min-w-90px btn btn-primary"
                            onClick={() => setOpenDialogThemMoi(true)}>
                      <i className="bi bi-plus-lg text-pri fs-3"></i>
                      Thêm
                    </Button>
                    <div className="d-flex">
                      <AutocompleteObjectV2
                        options={[{}]}
                        isSearchDefauilt={true}
                        name={"WmsCode"}
                        onChange={(options: any) => console.log(options)}
                        className="autocomplete-custom-renderform pl-5 radius spaces min-w-200 h-29"
                      />
                    </div>
                  </div>
                  <div className="flex-grow-1 ">
                    <InputSearch
                      name="keyword"
                      value={searchData?.keyword || ''}
                      placeholder="Tìm kiếm theo mã phiếu"
                      handleChange={handleChangeSearchData}
                      handleSearch={() => handlerSearchKeyWorld()}
                      handleKeyDown={(e: React.KeyboardEvent) => e.key === KEY.ENTER && handlerSearchKeyWorld()}
                      className="spaces h-31 pr-4 radius-3"
                    />
                  </div>
                </div>
                <div className="spaces bg-white mb-0">
                  <TableCustom<any>
                    className={`spaces ${className || "h-bang-ds-phieu"}`}
                    data={dsPhieuKeHoach}
                    columns={BaoCaoYCHTDialogColumns}
                    columnsActions={columnsActions}
                    verticalScroll={true}
                    selectionMode={SELECTION_MODE.SINGLE_NO_RADIO_BUTTON}
                  />
                  <TablePagination
                    handlePagesChange={handlePagesChange}
                    handleRowsPerPageChange={handleRowsPerPageChange}
                    rowsPerPage={rowsPerPage}
                    rowsForPage={rowsForPage}
                    page={page}
                    setPage={setPage}
                    setRowsPerPage={setRowsPerPage}
                    totalPages={Number(configTable.totalPages)}
                    totalElements={configTable.totalElements}
                    numberOfElements={configTable.numberOfElements}
                    hideTotalElements
                    customComponent={<WfStatusSummary summaryStatus={summaryStatus} col={4}/>}
                    className="border border-0"
                  />
                </div>
              </div>
            </div>
          </div>
          {openDialogThemMoi &&
              <DialogPhieuKeHoach
                  warehouseId={warehouseId}
                  type={typeKeHoach}
                  show={openDialogThemMoi}
                  onHide={handleCloseDialog}
                  initialValues={{keHoach: {...itemSelected}}}
                  setInitialValues={setItemSelected}
              />
          }
          {openDialogConfirmDelete &&
              <ConfirmDialog
                  show={openDialogConfirmDelete}
                  onCloseClick={handleCloseDialog}
                  onYesClick={handleDelete}
                  title="Xóa kế hoạch"
                  message={`Bạn chắc chắn muốn xóa phiếu: ${itemSelected.code} ?`}
                  yes="Xóa"
                  close="Hủy"
              />
          }
        </div>

      </div>

    </div>
  )
}

export default FormBaoCao;
